<div class="panel-header">
	<div class="column title">
		<h2>Gemiddelde aanwezigheid per lesuur</h2>
		<div class="subtitle">{{ maandDropdownState.getMaandMetJaar(schooljaar()) }}</div>
	</div>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-single-select-dropdown
			class="select-maand"
			[opties]="maandDropdownState.opties()"
			[selectedOptie]="maandDropdownState.selectedOptie()"
			(onOptieClicked)="maandDropdownState.setMaand($event)"
		></app-single-select-dropdown>
	</div>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="perLesuurInfo"></app-icon>
	</div>
	<ng-template #perLesuurInfo>
		<div class="tooltip">
			<h4>Gemiddelde aanwezigheid per lesuur</h4>
			<p>Toont de gemiddelde aanwezigheid van de geselecteerde leerlingen per lesuur in een gekozen maand.</p>
			<ol>
				<li>Goede aanwezigheid (groen): ≥ 95% aanwezig</li>
				<li>Beginnend verzuim (geel): &gt; 90% - &lt; 95% aanwezig</li>
				<li>Aanhoudend verzuim (rood): ≤ 90% aanwezig</li>
			</ol>
		</div>
	</ng-template>
</div>
<div class="panel-content">
	<app-aanwezigheid-matrix [data]="lesuurMatrixData()" [loading]="loading()"></app-aanwezigheid-matrix>
</div>
